import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';
/**
 * Shared rail-card primitives for Studio and other management surfaces
 * (`StudioItemCard` and its per-type wrappers).
 *
 * Home/content rails (`ContentRailCard` photo + caption, `CollectionRailCard` 16:9)
 * own their own poster styles. Width + gradient helpers below are still shared.
 */

/**
 * Fixed content-tile widths per breakpoint (home rails). Not vw-fluid.
 * Home livestream rail uses a larger `ContentRailCard` (`hero`).
 */
export const RAIL_CARD_WIDTH_MOBILE = '17rem';
export const RAIL_CARD_WIDTH_TABLET = '20rem';
export const RAIL_CARD_WIDTH = '24rem';
/** Search content tiles — one step smaller than collection cards at the same breakpoints. */
export const SEARCH_CONTENT_CARD_WIDTH_MOBILE = '14rem';
export const SEARCH_CONTENT_CARD_WIDTH_TABLET = '16.5rem';
export const SEARCH_CONTENT_CARD_WIDTH = '19rem';
/** Collection wrap grid: share leftover row space (1fr), cap so a lone tile cannot go full-pane. */
export const COLLECTION_GRID_MIN = '18rem';
export const COLLECTION_GRID_MAX = '30rem';

export const Card = styled.article`
  width: ${RAIL_CARD_WIDTH};
  flex-shrink: 0;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid ${Constants.HairlineBorderRgba};
  background: ${Constants.SurfaceColor};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  text-align: left;
  transition: box-shadow 0.15s ease;
  &:hover {
    box-shadow: ${Constants.CTAShadow};
  }
`;

export const Thumb = styled.div`
  flex: 0 0 auto;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background-size: cover;
  background-position: center top;
  background-color: ${Constants.isDarkMode ? '#2a2a2a' : '#e8e8e8'};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.85rem;
  box-sizing: border-box;
`;

export const ThumbFallbackTitle = styled.span`
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  letter-spacing: -0.01em;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
`;

export const Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.55rem 0.7rem 0.65rem;
  gap: 0.25rem;
  overflow: hidden;
`;

export const Kicker = styled.div`
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${Constants.MediumTextGray};
  line-height: 1.2;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 0.875rem;
  font-weight: 650;
  line-height: 1.3;
  color: ${Constants.DarkTextColor};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
`;

export const Meta = styled.div`
  font-size: 0.75rem;
  color: ${Constants.MediumTextGray};
  margin-top: 0.1rem;
`;

export {
  hashHue,
  fallbackGradient,
  gradientFromHsl,
  hexToHsl,
  gradientFromColor,
} from '../../utils/contentGradient';
